import React from 'react';
import { MdLockOutline } from "react-icons/md";

const PasswordInput = ({ password, handlePasswordChange, handlePasswordSubmit }) => {
  return (
    <form onSubmit={handlePasswordSubmit} className="mb-4">
      <div className="relative mb-4 mt-3">
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <MdLockOutline className="text-gray-500" size="24px" />
        </span>
        <input
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={handlePasswordChange}
          className="border border-gray-300 rounded-lg py-2 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>
    </form>
  );
};

export default PasswordInput;
